/* eslint react/prop-types: 0 */
import React from 'react';
import { isString } from 'lodash';
import { formatPrice } from '../../utils/money';
import Abbr from '../../shared/Abbr';

const columns = [
    {
        key: 'nominationYear',
        header: 'year',
    },
    {
        key: 'studFee',
        header: 'stud fee',
        cell: ({ studFee, currencyCode }) => (
            isString(studFee) ? studFee : `${currencyCode} ${formatPrice(studFee)}`
        ),
        sortFn: (a, b) => {
            if (isString(a.studFee)) { return 1; }
            if (isString(b.studFee)) { return -1; }
            return b.studFee - a.studFee;
        },
    },
    {
        key: 'countryDesc',
        header: () => (
            <Abbr title="country">cntry</Abbr>
        ),
        cell: ({ countryCode, countryDesc }) => (
            countryDesc && countryCode ?
                <Abbr title={countryDesc}>{countryCode}</Abbr>
                : '—'
        ),
        sortFn: 'alphabetic',
    },
    {
        key: 'studName',
        header: 'standing',
        sortFn: 'alphabetic',
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/feeHistory/columns.jsx